import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const CONTACT_TOURS = "viking@exclusivereykjavik.is";
const CONTACT_DINING = "catering@privatechef.is";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-[#050505] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h3 className="font-display font-extrabold text-2xl uppercase tracking-tighter">
            Immersion Festival
          </h3>
          <p className="text-gray-500 text-sm mt-4 max-w-xs leading-relaxed">
            Curated Icelandic excursions and intimate dining experiences for
            Immersion Festival guests. Five days and four nights at Viking Village,
            near Höfn.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-4">Experiences</p>
          <ul className="space-y-3 text-sm text-gray-300">
            <li><Link to="/tours" className="hover:text-white transition-colors">Iceland Expeditions</Link></li>
            <li><Link to="/#the-table" className="hover:text-white transition-colors">The Dining Experience</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-4">The Event</p>
          <ul className="space-y-3 text-sm text-gray-300">
            <li>Iceland · October 1–5, 2026</li>
            <li>Viking Village, near Höfn</li>
            <li>
              <a href="https://immersionfestival.com/" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">
                immersionfestival.com
              </a>
            </li>
          </ul>
          <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mt-8 mb-4">Questions or Issues?</p>
          <div className="space-y-3">
            <div>
              <p className="text-[10px] uppercase tracking-[0.15em] text-gray-600 mb-1">Tours</p>
              <a
                href={`mailto:${CONTACT_TOURS}`}
                data-testid="footer-contact-tours"
                className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors"
              >
                <Mail size={15} strokeWidth={1.75} />
                {CONTACT_TOURS}
              </a>
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-[0.15em] text-gray-600 mb-1">Dining</p>
              <a
                href={`mailto:${CONTACT_DINING}`}
                data-testid="footer-contact-dining"
                className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors"
              >
                <Mail size={15} strokeWidth={1.75} />
                {CONTACT_DINING}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-gray-600 uppercase tracking-[0.15em]">
          <span>© 2026 Immersion Experiences</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-gray-300 transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
